import { TrackerEvent } from './tracker-event';
import { loadScript } from '@fastcampus/browser-util';
import Debug from 'debug';

const debug = Debug('fc:tracker:daum');

export class DaumTracker {
  static create(opts, context) {
    return new DaumTracker(opts, context);
  }

  constructor({ id, userId }, context) {
    debug('init:', id, userId);
    this.id = id;
    this.userId = userId;

    context.DaumConversionAccountID = this.id;
    context.DaumTrackerFunction = (event, data) => {
      // 코드를 풀어서 정리한 이유는 CSRF 오류가 발생하기 때문 - document.write 때문에
      // 주문서작성 = 수강신청
      //var DaumConversionDctSv="type=W,orderID=,amount=";
      // 회원가입
      //var DaumConversionDctSv="type=M,orderID=,amount=";
      // 상품구매 = initialCheckout
      //var DaumConversionDctSv="type=P,orderID=,amount=";
      context.DaumConversionDctSv =
        'type=' + event
          ? event.toString()
          : '' + ',orderID=' + data.id
          ? data.id.toString()
          : '' + ',amount=' + data.amount
          ? data.amount.toString()
          : '';
      context.DaumConversionScriptLoaded = true;
      loadScript('https://t1.daumcdn.net/cssjs/common/cts/vr200/dcts.js')
        .then(() => debug('install ok!'))
        .catch((err) => debug('install err!', err));
    };
    // 다음 CTS 는 전역변수(DaumConversionAccountID, DaumConversionDctSv, ...)의 값을
    // 스크립트를 로딩할때 파라메터로 전달하는 방식 -> connect!
    this.daum = DaumTrackerFunction;
    this.ready = true;
  }

  track(event, data) {
    if (!this.ready) {
      return debug('**ignore** not ready!', event, data);
    }
    debug('track:', event, data);
    switch (event) {
      case TrackerEvent.PAGE_VIEW:
        break;
      case TrackerEvent.USER_SIGNUP:
        this.daum('M', { id: this.userId, amount: 0 });
        break;
      case TrackerEvent.USER_LOGIN:
        break;
      case TrackerEvent.CATEGORY_VIEW:
        break;
      case TrackerEvent.COURSE_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_PENDING:
        if (data) {
          const product = data;
          this.daum('W', { id: product.id, amount: product.salePrice });
        }
        break;
      case TrackerEvent.TRANSACTION_ORDER:
        break;
      case TrackerEvent.TRANSACTION_PAYMENT:
        const payload = {};
        if (data && data.transactionInfo && data.transactionInfo.transaction) {
          payload.amount = data.transactionInfo.transaction.amount;
          payload.id = data.transactionInfo.transaction.id;
        }
        this.daum('P', payload);
        break;
    }
  }
}
